import * as React from 'react';
import InvoiceCommercial from './InvoiceCommercial';
import InvoiceBroker from './InvoiceBroker';
import InvoiceSeller from './InvoiceSeller';
import { IInvoiceInformation, InvoiceSellerApi } from '../query/InvoiceSellerApi';
import { useQuery } from 'react-query';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../../telemetry/utils';

export enum InvoiceReceiver {
    Broker = 1,
    Commercial = 2,
    Seller = 3
}

type ExternalProps = {
    orderId: number;
    user: AuthenticatedUser;
};

type InvoiceInformationProps = {
    info: IInvoiceInformation;
    orderId: number;
};

function InvoiceInformation({ info, orderId }: InvoiceInformationProps) {
    if (!info) {
        return null;
    }

    let { invoiceReceiverType, invoiceReceiverEmail, invoiceReceiverName, canEdit } = info;

    if (invoiceReceiverType.value === InvoiceReceiver.Broker) {
        return <InvoiceBroker receiverTranslationKey={invoiceReceiverType.displayName} />;
    } else if (invoiceReceiverType.value === InvoiceReceiver.Commercial) {
        return <InvoiceCommercial receiverTranslationKey={invoiceReceiverType.displayName} />;
    } else if (invoiceReceiverType.value === InvoiceReceiver.Seller) {
        return (
            <InvoiceSeller
                email={invoiceReceiverEmail}
                reference={invoiceReceiverName}
                receiverTranslationKey={invoiceReceiverType.displayName}
                orderId={orderId}
                canEdit={canEdit}
            />
        );
    }

    return null;
}

export let InvoiceInformationQueryCacheKey = 'InvoiceInformation';

export default function InvoiceInformationDataLayer({ orderId, user }: ExternalProps) {
    let { data, isError, error } = useQuery([InvoiceInformationQueryCacheKey], () =>
        InvoiceSellerApi.getInvoiceInformation(orderId)
    );
    let { logger } = useTelemetryContext();

    if (isError) {
        let additionalInfo = {
            origin: 'InvoiceInformationDataLayer',
            userInfo: getUserInfo(user)
        };

        logger.logException(error, additionalInfo);

        return null;
    }

    return <InvoiceInformation info={data} orderId={orderId} />;
}
